import type { StoryblokRichtext } from '@percent/cause-dashboard/storyblok/types/storyblok.d.ts'
import { storyblokRichtextDocToReact } from './storyblokNodesToReact'
import styles from './RichTextRenderer.module.scss'

export type RichTextRendererProps = {
  /** Storyblok rich text (ProseMirror JSON root, `type: "doc"`). */
  document: StoryblokRichtext | undefined | null
  className?: string
  /** Narrow inner layout when embedded inside a product-offer CTA card (full-width doc, no outer max-width). */
  variant?: 'default' | 'nestedInCard'
}

/**
 * Renders Storyblok basic rich text (headings, paragraphs, lists, marks) using Lemonade Typography patterns.
 */
export function RichTextRenderer({ document, className, variant = 'default' }: Readonly<RichTextRendererProps>) {
  const rootClass =
    variant === 'nestedInCard'
      ? `${styles.wrapper} ${styles.wrapperNestedInCard}${className ? ` ${className}` : ''}`
      : className ?? styles.wrapper

  return <div className={rootClass}>{storyblokRichtextDocToReact(document)}</div>
}
